export const loadingMessages = [
  "Working our magic ✨",
  "Almost there!",
  "Brewing something awesome...",
  "Just a moment...",
  "Loading your goodies...",
  "Putting pieces together...",
  "Creating something special...",
  "Getting things ready...",
  "Hang tight!",
  "Making it perfect...",
  "Loading with love ❤️",
  "Almost done!",
  "Crafting your experience...",
  "Spinning the wheels... 🐹",
  "Working hard for you!",
  "Gathering digital magic...",
  "Loading awesome content...",
  "Preparing something great...",
  "Just a sec!",
  "Making things beautiful...",
  "Loading happiness...",
  "Getting everything perfect...",
  "Working at light speed!",
  "Creating digital magic ✨",
  "Loading your adventure...",
  "Putting on finishing touches...",
  "Almost ready!",
  "Loading good vibes...",
  "Making it amazing...",
  "Working behind scenes...",
  "Loading awesomeness...",
  "Getting things just right...",
  "Creating your moment...",
  "Loading with care...",
  "Making magic happen ✨",
  "Working for you!",
  "Loading something special...",
  "Getting ready...",
  "Creating perfect experience...",
  "Loading greatness...",
  "Working our best!",
  "Loading wonderful things...",
  "Making it shine ✨",
  "Getting everything ready...",
  "Loading pure awesome...",
  "Working with passion!",
  "Loading your perfect moment...",
  "Creating digital joy...",
  "Getting closer..."
];
